class ProductCardVariantChange  extends HTMLElement {
    constructor() {
        super();
        const _this = this;
        this.radioButons = this.querySelectorAll('input[type="radio"]')
        if(this.radioButons){
            this.radioButons.forEach(function (input){
                input.addEventListener('change', _this.ChangeVariant.bind(_this));
            })
        }

    }
    ChangeVariant(){
        this.GetOptions();
        this.GetVariantId();
        this.UpdateContent();

    }
    GetOptions() {
        /* options change*/
        const fieldsets = Array.from(this.querySelectorAll('[data-product-options-group]'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
    GetVariantId(){
        const variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        /* options change*/
        this.currentVariant = variantJson.find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    UpdateContent(){
      if (!this.currentVariant){
            if(this.closest('product-form').querySelector('button[name="add"]')){
                this.closest('product-form').querySelector('form').querySelector('button[name="add"]').setAttribute('disabled','disabled');
                this.closest('product-form').querySelector('form').querySelector('button[name="add"]').innerHTML = window.translation.out_of_stock;
            }
            return
        }
        this.closest('product-form').querySelector('form').querySelector('input[name="id"]').value =this.currentVariant.id;
        console.log(this.currentVariant)
        if(this.currentVariant.available == false){
            this.closest('product-form').querySelector('form').querySelector('button[name="add"]').setAttribute('disabled','disabled');
            this.closest('product-form').querySelector('form').querySelector('button[name="add"]').innerHTML = window.translation.sold_out;
        }else{
            this.closest('product-form').querySelector('form').querySelector('button[name="add"]').removeAttribute('disabled');
            this.closest('product-form').querySelector('form').querySelector('button[name="add"]').innerHTML = window.translation.add_to_cart;
        }
    }

}
customElements.define('product-card-option', ProductCardVariantChange )

